var $ = require('jquery');
var extend = require('extend');
var mapPlacesFilterTemplate = require('../templates/client/s2-mapPlacesFilters.hbs');
var placeInfoWindowTemplate = require('../templates/client/googlePlaceFlyout.hbs');
var ResponsiveUtils = require('utils/responsiveUtils');
var Promise = require('bluebird');

/**
 * Constructor method for MapPlacesFilters
 * @param {Object} $el -  jQuery element
 * @param {Object} mapHandler - Google map handler for property record
 */
function MapPlacesFilters($el, mapHandler, mapPlacesClickHandler) {

  this.options = this.getOptions($el.data('options') || {});
  this.mapHandler = mapHandler;
  this.mapPlacesClickHandler = mapPlacesClickHandler;
  this.data = null;
  this.service = new google.maps.places.PlacesService(this.mapHandler.getMap());
  this.propertyListEl = this.mapHandler.$el.parents('.map-view-wrapper').find('.map-base-view');

  // initializing responsive utils
  this.initResponsiveUtils();

  this.$el = this.addMapPlacesFiltersDOM();
  this.bindEvents();
  this.propertyMarkerMouseEventHandler();


  // adding places info container for mobile devices
  if(this.responsiveUtils.isMobileOrTablet()) {
    this.mobilePlaceInfoWindow = $('<div class="place-info-window clearfix">'+
      '<span class="google-flyout-close icon-common filter-close-icon">'+
      '</span><div class="flyout-container"></div></div>');
    this.mapHandler.$el.append(this.mobilePlaceInfoWindow);    
    this.mobilePlaceInfoWindow.find('.google-flyout-close').on('click', this, this.closeGooglePlacesFlyout);
  }
}

// Map Places Filters API
var MapPlacesFiltersAPI = {
  /*
  * intiating responsive utils
  */
  initResponsiveUtils: function () {
    this.responsiveUtils = ResponsiveUtils.create();
    this.responsiveUtils.init();
  },
  /**
   * Add PlacesMapFiltersOverlay to the map
   * @returns {Object} jQuery element for PlacesMapFiltersOverlay to the map
   */
  addMapPlacesFiltersDOM: function() {
    var toggleHeader;
    var mapPlacesFilterEl = $(mapPlacesFilterTemplate(this.options))[0];
    var form = mapPlacesFilterEl.querySelector('form');

    this.mapHandler.getMapEl().appendChild(mapPlacesFilterEl);

    this.setResultStructure(mapPlacesFilterEl)
    this.bindMapPlacesFiltersEvents(mapPlacesFilterEl);
    return $(mapPlacesFilterEl);
  },

  /**
   * Set data structure to store marker wrappers for places
   * @param {Object} mapPlacesFilterEl - jquery map places filters object
   */
  setResultStructure: function(mapPlacesFilterEl) {
    var self = this;
    var form = mapPlacesFilterEl.querySelector('form');

    self.data = {};

    Array.prototype.forEach.call(form.mapPlaceFilter, function(input) {
      self.data[input.value] = [];
    });
  },

  /**
   * Bind map places filters events
   * @param {Object} mapPlacesFilterEl - jquery map places filters object
   */
  bindMapPlacesFiltersEvents: function(mapPlacesFilterEl) {
    var self = this;
    var form = mapPlacesFilterEl.querySelector('form');

    Array.prototype.forEach.call(form.mapPlaceFilter, function(input) {
      input.addEventListener('change', function(evt) {
        self.onPlacesFiltersChange(evt.target);
      });

      // Adding mouse event handlers for desktops only
      if(!self.responsiveUtils.isDevice()) {
        input.parentNode.addEventListener('mouseover', self.onPlacesFiltersMouseOver.bind(self, input.parentNode));
        input.parentNode.addEventListener('mouseout', self.onPlacesFiltersMouseOut.bind(self, input.parentNode));
      }      
    });
  },

  /**
   * Map places filters change event handler
   * @param {Object} evt - Change event handler
   */
  onPlacesFiltersChange: function(target) {
    if (target.checked) {
      this.service.nearbySearch(this.getSearchQueryByInput(target), this.nearbySearchSuccess.bind(this, target.value));
    } else {
      this.hideMarkers(this.data[target.value]);
    }
  },

  /**
   * Mouseover event handler for google place filter
   * @param {Object} evt - Mouseover event handler
   */
  onPlacesFiltersMouseOver: function(label) {
    $(label).addClass('hover');
  },

  /**
   * Mouseout event handler for google place filter
   * @param {Object} evt - Mouseover event handler
   */
  onPlacesFiltersMouseOut: function(label) {
    $(label).removeClass('hover');
  },

  /**
   * Bind map event handlers
   */
  bindEvents: function() {
    var map = this.mapHandler.getMap();
    var _self = this;
    map.addListener('click', function() {
      _self.mapHandler.isInfoWindowPersist = false;
      _self.closeAllInfoWindow.call(_self);
    });
    map.addListener('zoom_changed', this.mapZoomChangeEventHandler.bind(this));
    document.body.addEventListener('click', this.documentClickHandler.bind(this));
  },

  /**
   * Create PlaceRequestObject for map places search
   * @param {Object} input - Input field that triggered changes
   * @returns {Object} - PlaceRequestObject
   */
  getSearchQueryByInput: function(input) {
    var searchQuery = {
      bounds: this.mapHandler.getMap().getBounds()
    };

    type = input.getAttribute('data-filter-type');

    switch (type) {
      case 'place':
        searchQuery.type = input.value;
        break;
      default:
        searchQuery.keyword = input.value;
    }

    return searchQuery;
  },

  /**
   * Google place marker click handler
   * @param {Object} markerWrapper - Marker wrapper object
   */
  markerClickHandler: function(markerWrapper) {
    this.closeAllInfoWindow();
    this.openAndPersistInfoWindow(markerWrapper);
  },
  
  /**
   * Close Map Places Filter dropdown
   */
  closeMapPlacesFilter : function(e) {
    if (e && ($(e.target).closest(".map-places-filters").length > 0)) {
      return;
   }
    this.$el.find('.m-dropdown').removeClass('in-focus');
  },

  /** 
   * Close all infowindows on the map
   */
  closeAllInfoWindow: function() {
    var self = this;
    this.mapHandler.$el.find('.m-dropdown-trigger').addClass('is-hidden');
    // return if data is not populated yet
    if (this.data === null) {
      return;
    }

    Object.keys(this.data).forEach(function(key) {
      self.data[key].forEach(function(marker) {
        self.closeInfoWindow(marker);
      });
    });

    // hiding places flyout for mobile and showing property list
    if(self.mobilePlaceInfoWindow) {
      self.mobilePlaceInfoWindow.addClass('flyout-hidden');
      self.mobilePlaceInfoWindow.find('.flyout-container').html("");
    }    
    self.propertyListEl.removeClass('property-list-hidden'); 
  },

  /**
   * Document click handler
   */
  documentClickHandler: function(evt) {
    var $target = $(evt.target),
      $map = $(this.mapHandler.getMapEl());

    if ($map.find($target).length === 0) {
      this.mapHandler.isInfoWindowPersist = false;
      this.closeAllInfoWindow();
    }
    this.mapPlacesClickHandler(false);
    this.closeMapPlacesFilter(evt);
  },

  /**
   * Close marker wrapper object's infowindow
   * @param {Object} markerWrapper object
   */
  closeInfoWindow: function(markerWrapper) {
    var content = markerWrapper.infoWindow.getContent();
    var toggleCheckbox = content ? content.querySelector('[name="toggleOpenTimings"]') : null;
    this.preventMarkerPinUpdate = false;
    if (toggleCheckbox) {
      toggleCheckbox.checked = false;
    }

    if (markerWrapper.nativeMarker) {
      markerWrapper.nativeMarker.setIcon(this.getMarkerIcon(markerWrapper.markerType));
      markerWrapper.infoWindow.close();
    }
  },

  /**
   * Show all markers of markerWrapperList on the map 
   * @param {Array} markerWrapperList - Array list of markerWrapper objects
   */
  showMarkers: function(markerWrapperList) {
    markerWrapperList.forEach(this.showMarker.bind(this));
  },

  /**
   * Show native marker of markerWrapper object on the map
   * @param {Array} markerWrapper - markerWrapper object
   */
  showMarker: function(markerWrapper) {
    markerWrapper.nativeMarker.setMap(this.mapHandler.getMap());
  },

  /**
   * Hide all markers of markerWrapperList on the map 
   * @param {Array} markerWrapperList - Array list of markerWraper objects
   */  
  hideMarkers: function(markerWrapperList) {
    markerWrapperList.forEach(this.hideMarker.bind(this));
  },

  /**
   * Hide native marker of markerWrapper object on the map
   * @param {Array} markerWrapper - markerWrapper object
   */
  hideMarker: function(markerWrapper) {
    markerWrapper.nativeMarker.setMap(null);
  },

  /**
   * Open info window of markerWrapper object on the map
   * @param {Array} markerWrapper - markerWrapper object
   */
  openInfoWindow: function(markerWrapper) {
    var _self = this;
    this.closeAllInfoWindow();
    this.preventMarkerPinUpdate = true;
    if (!this.propertyListEl.length) {
      this.propertyListEl = this.mapHandler.$el.parents(".map-view-wrapper").find(".map-base-view");
    }

    console.info(markerWrapper);

    if(this.responsiveUtils.isMobileOrTablet()) {
      if (!this.mobilePlaceInfoWindow) {
        this.mobilePlaceInfoWindow = $('<div class="place-info-window clearfix">'+
        '<span class="google-flyout-close icon-common filter-close-icon">'+
        '</span><div class="flyout-container"></div></div>');
        this.mapHandler.$el.append(this.mobilePlaceInfoWindow);    
        this.mobilePlaceInfoWindow.find('.google-flyout-close').on('click', this, this.closeGooglePlacesFlyout);
      }
      this.propertyListEl.addClass('property-list-hidden');
      this.mapPlacesClickHandler(true);
      _.defer(function() {
        _self.mobilePlaceInfoWindow.removeClass('flyout-hidden').find('.flyout-container').html(markerWrapper.infoWindow.getContent()); 
      });      
    } else {
      markerWrapper.infoWindow.open(this.mapHandler.getMap(), markerWrapper.nativeMarker);
      $(_self.mapHandler.getMapEl()).find('.gm-style-iw').parent().css("visibility", "hidden");
    }
  },
  /**
   * Open info window of markerWrapper object on the map and set isInfoWindowPersist flag to TRUE
   * @param {Array} markerWrapper - markerWrapper object
   */
  openAndPersistInfoWindow: function(markerWrapper) {
    var _self = this;
    markerWrapper.loadContent().then(function() {
      _self.mapHandler.isInfoWindowPersist = true;
      markerWrapper.nativeMarker.setIcon(_self.getMarkerIcon(markerWrapper.markerType, true));
      _self.mapHandler.$el.find('.m-dropdown-trigger').removeClass('is-hidden');
    });
  },

  /**
   * Search result handler for google places nearby search
   * @param {string} searchResultKey - Search category like restaurant, transit_station, attractions
   * @param {Array} searchResult - Google places search result
   * @param {string} searchResultStatus - Google places search result status like OK, ZERO_RESULT, UNKNOWN_ERROR
   */
  nearbySearchSuccess: function(searchResultKey, searchResult, searchResultStatus) {
    var self = this;

    if (searchResultStatus === 'OK') {
      this.removeExistingPlaces(this.data[searchResultKey]);
      this.closeAllInfoWindow();
      this.data[searchResultKey] = this.parseSearchResult(searchResultKey, searchResult.slice(0, this.options.placesLimit));
    }
  },

  /**
   * Parse earch results and set marker wrapper object list
   * @param {string} searchResultKey - Search category like restaurant, transit_station, attractions
   * @param {Array} searchResult - Google places search result
   */
  parseSearchResult: function(searchResultKey, searchResult) {
    var self = this;

    return searchResult.map(function(place) {
      //Fix for SRPE-34393 - lodging marker should not be shown for attractions
      if (!(searchResultKey == 'attractions' && place.types[0] == 'lodging')) {
        var markerWrapper = {
          markerType: searchResultKey,
          place: place
        };

        // add marker
        markerWrapper.nativeMarker = self.addPlaceMarker(self.getMarkerOptions(place));
        markerWrapper.nativeMarker.setIcon(self.getMarkerIcon(searchResultKey));
        self.bindMarkerEvents(markerWrapper);

        // add infowindow
        markerWrapper.infoWindow = new google.maps.InfoWindow();
        self.bindInfoWindowEvents(markerWrapper);

        markerWrapper.loadContent = function() {
          return new Promise(function(resolve, reject) {
            self.service.getDetails(
              {
                placeId: markerWrapper.place.place_id
              }, 
              function(data) {
                if (markerWrapper.isHovered !== false) {
                  self.placeDetailSuccess.call(self, markerWrapper, data);
                }
                resolve();
              }
            );
          });
        }

        return markerWrapper;
      }
    }).filter(function(marker) {
      return typeof marker !== 'undefined';
    });
  },

  /**
   * Add Google marker on the map
   * @param {Object} markerOptions - Google marker options
   * @returns {Object} - Google marker instance
   */
  addPlaceMarker: function(markerOptions) {
    return this.mapHandler.addMarker(markerOptions);
  },

  /**
   * Returns request object for Google places marker
   * @param {object} place - Place object as returned in response through api
   * @returns {object} - request object for Google places marker
   */
  getMarkerOptions: function(place) {
    return {
      position: {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      },
      map: this.mapHandler.getMap()
    };
  },

  /**
   * Returns icon url for Google places marker
   * @param {string} key - Search category name
   * @param {boolean} - if TRUE returns active icon url
   * @returns {string} - Google marker icon url
   */
  getMarkerIcon: function(key, active) {
    var icon = null;

    switch (key) {
      case 'restaurant':
        icon = active ? this.options.mapPins.restaurantIconActive : this.options.mapPins.restaurantIcon;
        break;

      case 'transit_station':
        icon = active ? this.options.mapPins.transitStationIconActive : this.options.mapPins.transitStationIcon;
        break;

      case 'attractions':
        icon = active ? this.options.mapPins.attractionsIconActive : this.options.mapPins.attractionsIcon;
        break;
    }

    return icon;
  },

  /**
   * Bind mouseover, mouseout and click event handler to marker
   * @param {Object} markerWrapper - markerWrapper object
   */
  bindMarkerEvents: function(markerWrapper) {

    // add mouseover/mouseout events to desktop only
    if(this.responsiveUtils.isMobileOrTablet() !== true) {
      google.maps.event.addListener(markerWrapper.nativeMarker, 'mouseover', this.markerMouseOverHandler.bind(this, markerWrapper));
      google.maps.event.addListener(markerWrapper.nativeMarker, 'mouseout',  this.markerMouseOutHandler.bind(this, markerWrapper));
    }

    markerWrapper.nativeMarker.addListener('click', this.markerClickHandler.bind(this, markerWrapper));
  },

  /**
   * Bind infowindow event handlers
   * @param {Object} markerWrapper - markerWrapper object
   */
  bindInfoWindowEvents: function(markerWrapper) {
    // 
    markerWrapper.infoWindow.addListener('closeclick', this.closeInfoWindow.bind(this, markerWrapper));
  },

  /**
   * Mouseover event handler for marker
   * @param {Object} markerWrapper - markerWrapper object
   */
  markerMouseOverHandler: function(markerWrapper) {
    // if map already has infoWindow opened or if marker cluster is hovered
    if (this.mapHandler.isInfoWindowPersist || this.mapHandler.isMarkerClusterHovered) {
      this.mapHandler.isMarkerClusterHovered = false;
      return;
    }
    markerWrapper.isHovered = true;
    markerWrapper.loadContent();
  },

  /**
   * Mouseout event handler for marker
   * @param {Object} markerWrapper - markerWrapper object
   */
  markerMouseOutHandler: function(markerWrapper) {

    // if map already has infoWindow opened
    if (this.mapHandler.isInfoWindowPersist) {
      return;
    }

    markerWrapper.isHovered = false;
    this.closeInfoWindow(markerWrapper);
  },

  /**
   * Compiles infowindow template with data
   * @param {Object} markerWrapper - markerWrapper object
   */
  generateFlyoutContent: function(markerWrapper) {
    var data = {
      name: markerWrapper.place.name,
      imageUrl: '',
      address: null,
      rating: markerWrapper.place.rating,
      ratingIcons: this.generateRating(markerWrapper.place.rating),
      priceLevel: this.generatePriceLevel(markerWrapper.place.price_level),
      openTimings: markerWrapper.placeDetail ? this.parseOpenTimings(markerWrapper.placeDetail) : null
    };

    // set image url 
    if (markerWrapper.place.photos) {
      data.imageUrl = markerWrapper.place.photos[0] ? markerWrapper.place.photos[0].getUrl({maxWidth: 100, maxHeight: 100}) : null;
    }

    // set place detail
    if (markerWrapper.placeDetail) {
      data.address = this.parseAddressComponents(markerWrapper.placeDetail.address_components);
    }

    if(this.responsiveUtils.isMobileOrTablet()){
      data.isDevice = true;
      this.mapHandler.$el.find('.place-info-window .flyout-container').html(placeInfoWindowTemplate(data));        
    }

    return $(placeInfoWindowTemplate(data))[0];
  },

  /**
   * Generate rating icon list
   * @param {Number} rating - Rating
   * @returns {Array} - Rating icon list
   */
  generateRating: function(rating) {
    if (!rating) {
      return null;
    }

    return [1, 2, 3, 4, 5].map(function(item) {
      var counter = item + 1;
      var icon;

      if (item === Math.ceil(rating) && item !== rating) {
        icon = 'star-icon-half';
      } else if (rating >= item) {
        icon = 'star-icon-full';
      } else {
        icon = 'star-icon-none';
      }

      return icon;
    });
  },

  /**
   * Generate price level list
   * @param {Number} priceLevel - Google place price level
   * @returns {Array} - Price level array
   */
  generatePriceLevel: function(priceLevel) {
    var list = [];

    if (!priceLevel) {
      return null;
    }

    while(priceLevel > 0) {
      list.push('$');
      priceLevel--;
    }

    return list;
  }, 

  /**
   * Parse Google place detail open/close timings
   * @param {Object} placeDetail - Google place detail
   * @returns {Object} - Parsed open/close timings
   */
  parseOpenTimings: function(placeDetail) {
    var data = {openCloseStatus: ''};
    var curdate = new Date();
    var day = curdate.getDay();
    var hours = curdate.getHours();
    var period = null;
    var openingClosingSoonDelay = 1;
    var weakTimeText, timingsArray;

    // permanently closed
    if (placeDetail.permanently_closed) {
      data.openCloseStatus = this.options.flyoutLabels.closed;
    } else if (placeDetail.opening_hours) {

      // weekday text
      if (placeDetail.opening_hours.weekday_text) {
        data.weekdayText = this.createTimingsArray(placeDetail.opening_hours.weekday_text);
        weakTimeText = data.weekdayText[0].timings;
      }

      // open now
      if (placeDetail.opening_hours.open_now) {
        data.openCloseStatus = this.options.flyoutLabels.openNow + ' ' + weakTimeText;
      } else if (placeDetail.opening_hours.periods && placeDetail.opening_hours.periods[day]) {
        period = placeDetail.opening_hours.periods[day];
        if (period.open && (hours + openingClosingSoonDelay) === period.open.hours) {
          data.openCloseStatus = this.options.flyoutLabels.openingSoon + ' ' + weakTimeText;
        } else if (period.close && (hours + openingClosingSoonDelay) === period.close.hours) {
          data.openCloseStatus = this.options.flyoutLabels.closingSoon + ' ' + weakTimeText;
        } else {
          data.openCloseStatus = this.options.flyoutLabels.closed;
          if (weakTimeText.toLowerCase().replace(/\s/g, '') !== 'closed') {
            data.openCloseStatus += ' (' + this.options.flyoutLabels.openingText + ': ' + weakTimeText + ')';
          }
        }
      }
    }

    return data;
  },

  /**
   * Creates timings array to be sent to google places flyout html template
   * @param {Object} weekdayText - Weekly open/close timing list as returned by google api
   * @returns {Object} - Timing array to be returned to template
   */
  createTimingsArray: function(weekdayText) {
    var timings_array = [];

    weekdayText.forEach(function(item) {
      var timingArr = item.split(': ');
      timings_array.push({
        day: timingArr[0],
        timings: timingArr[1]
      })
    });

    return timings_array;
  },

  /**
   * Parse google place address components to create address info
   * @param {Array} addressComponents - Google place detail address components
   * @returns {Array} - Parsed address component address list
   */
  parseAddressComponents: function(addressComponents) {
    var address1 = [];
    var address2 = [];

    addressComponents.forEach(function(item) {
      switch(item.types[0]) {
        case 'street_number':
        case 'route':
            address1.push(item.short_name);
          break;
        case 'locality':
        case 'postal_code':
          address2.push(item.long_name);
          break;
        case 'administrative_area_level_1':
          address2.push(item.short_name);
          break;
      }
    });

    return [address1.join(' '), address2.join(', ')];
  },

  /**
   * Success handler for google place detail request
   * @param {Object} markerWrapper - MArkerWrapper object
   * @param {Object} placeDetail - Google place detail object
   */
  placeDetailSuccess: function(markerWrapper, placeDetail) {
    var _self = this;
    markerWrapper.placeDetail = placeDetail;
    this.openInfoWindow(markerWrapper);
    var data = this.generateFlyoutContent(markerWrapper);
    markerWrapper.infoWindow.setContent(data);  
    google.maps.event.addListener(markerWrapper.infoWindow, 'domready', function() {
      $(_self.mapHandler.getMapEl()).find('.gm-style-iw').parent().css("visibility", "visible");
    });   
    markerWrapper.loadContent = function() {
      return new Promise(function(resolve, reject) {
        _self.openInfoWindow(markerWrapper);
        resolve();
      });
    }
    if(this.mapHandler.isInfoWindowPersist) {
      // show dropdown on first render
      _self.mapHandler.$el.find('.m-dropdown-trigger').removeClass('is-hidden');
    };
  },

  /**
   * Map click event handler
   */
  mapClickEventHandler: function() {
    this.mapHandler.isInfoWindowPersist = false;
    this.closeAllInfoWindow();
  },

  /**
   * Toggles map places filters category dropdown
   * @param {HtmlElement} mapPlacesFilterEl - Map places filters element
   */
  toggleMapFilters: function(mapPlacesFilterEl) {
    $(mapPlacesFilterEl.querySelector('.filter-dropdown-icon')).toggleClass("filter-close-icon");
    $(mapPlacesFilterEl.querySelector('.map-places-section')).slideToggle();
    this.mapHandler.isInfoWindowPersist = false;
    this.closeAllInfoWindow();
  },

  /*
  * Hiding google places flyout in mobile 
  */
  closeGooglePlacesFlyout: function(event){ 
    var self = event.data; 
    
    self.mobilePlaceInfoWindow.addClass('flyout-hidden');
    self.mobilePlaceInfoWindow.find('.flyout-container').html("");    
    self.propertyListEl.removeClass('property-list-hidden'); 
    self.mapPlacesClickHandler(false);
  },

  /**
   * Add moouse event handlers to property markers
   */
  propertyMarkerMouseEventHandler: function() {
    var self = this;

    self.mapHandler.markers.forEach(function(marker) {
      marker.addListener('mouseover', function() {
        self.mapHandler.isInfoWindowPersist = true;
      });

      marker.addListener('mouseout', function() {
        self.mapHandler.isInfoWindowPersist = false;
      });
    });    
  },

  /**
   * Map zoom changed event handler
   */
  mapZoomChangeEventHandler: function() {
    var _self = this;
    _.defer(function(){
      var mapPlaceFilters = _self.$el[0].querySelector('form').mapPlaceFilter;
      for (var i = 0, n = mapPlaceFilters.length; i < n; i++) {
        _self.onPlacesFiltersChange(mapPlaceFilters[i]);
      }
    });
  },

  /**
   * Remove existing places on the map
   * @param {Object} markerWrappers - MarkerWrapper List
   */
  removeExistingPlaces: function(markerWrappers) {
    markerWrappers.forEach(function(markerWrapper) {
      markerWrapper.nativeMarker.setMap(null);
    });
  },

  /**
   * Returns map places filters options 
   */
  getOptions: function(options) {
    var defaultOptions = {
      placesLimit: 20
    };

    return extend(defaultOptions, options);
  }
}

extend(MapPlacesFilters.prototype, MapPlacesFiltersAPI);

module.exports = MapPlacesFilters;
